import { HTMLAttributes } from 'react'
import * as Portal from '@radix-ui/react-portal'

import Logo from '@/components/base/logo'
import Typography from '@/components/base/typography'
import LanguageList from '@/components/layout/language-list'
import { useStore } from '@/contexts/store'
import { useLocaleStore } from '@/store/locale'
import { sanitizeOfficialWebsiteLink } from '@/utils/path'

import { cn } from '@/lib/utils'

export type HeaderProps = HTMLAttributes<HTMLElement> &
  Partial<{
    items: {
      link: {
        url: string
        title: string
        target?: string
      }
      is_mobile_visible: boolean
    }[]
  }>

const Header = ({ items, className, ...props }: HeaderProps) => {
  const currentLocale = useLocaleStore((state) => state.currentLocale)
  const { strings } = useStore()
  const { labels } = strings || {}

  return (
    <Portal.Root>
      <header
        className={cn(
          className,
          'fixed left-0 top-0 z-header flex h-header-height w-full items-center justify-between bg-black px-[3rem]'
        )}
        {...props}
      >
        <div className="hidden md:flex">
          <div className="'overflow-hidden'">
            <Typography
              className="flex text-[1.28rem] capitalize tracking-[0.0384rem] text-white/50"
              data-motion-place
            >
              {labels?.place}
            </Typography>
          </div>
        </div>

        <div className="relative md:absolute md:left-1/2 md:z-header md:-translate-x-1/2">
          <a // eslint-disable-line
            href={currentLocale == 'it' ? '/' : `/${currentLocale}`}
            className="-m-[1rem] flex p-[1rem]"
          >
            <Logo />
          </a>
        </div>

        <div className="relative z-header">
          <div className={cn('flex items-center gap-[2rem]')}>
            <div className="flex gap-[2rem]">
              {items?.map((item, index: number) => (
                <a
                  key={index}
                  href={sanitizeOfficialWebsiteLink(item.link)}
                  target={item?.link?.target || '_self'}
                  className={cn('link -m-[1rem] flex p-[1rem] text-white', {
                    'hidden md:flex': !item.is_mobile_visible
                  })}
                  data-gtm-event="book-cta"
                >
                  <Typography className="pointer-events-none text-[1rem] font-bold uppercase leading-[1.2] tracking-[0.05rem]">
                    {item?.link?.title}
                  </Typography>
                </a>
              ))}
            </div>
            <LanguageList />
          </div>
        </div>
      </header>
    </Portal.Root>
  )
}

export default Header
